/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Dow Jones List State
 * @export
 * @interface InternalApiDowJonesListState
 */
export interface InternalApiDowJonesListState {
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiDowJonesListState
     */
    isLastIncrementalUpdateInSafeTimeframe: boolean;
}

/**
 * Check if a given object implements the InternalApiDowJonesListState interface.
 */
export function instanceOfInternalApiDowJonesListState(value: object): value is InternalApiDowJonesListState {
    if (!('isLastIncrementalUpdateInSafeTimeframe' in value) || value['isLastIncrementalUpdateInSafeTimeframe'] === undefined) return false;
    return true;
}

export function InternalApiDowJonesListStateFromJSON(json: any): InternalApiDowJonesListState {
    return InternalApiDowJonesListStateFromJSONTyped(json, false);
}

export function InternalApiDowJonesListStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiDowJonesListState {
    if (json == null) {
        return json;
    }
    return {
        
        'isLastIncrementalUpdateInSafeTimeframe': json['isLastIncrementalUpdateInSafeTimeframe'],
    };
}

export function InternalApiDowJonesListStateToJSON(json: any): InternalApiDowJonesListState {
    return InternalApiDowJonesListStateToJSONTyped(json, false);
}

export function InternalApiDowJonesListStateToJSONTyped(value?: InternalApiDowJonesListState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isLastIncrementalUpdateInSafeTimeframe': value['isLastIncrementalUpdateInSafeTimeframe'],
    };
}

